import { Routes } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { WholesalerPharmacyGuard } from './wholesaler-pharmacy';

export const influenzaRoutes: Routes = [
  {
    path: 'influenza',
    children: [
      {
        path: 'dashboard',
        component: PageLayoutComponent,
        data: { pageLabel: '/influenza/dashboard' },
        canActivate: [CmsPageGuard],
      },
      {
        path: 'category',
        component: PageLayoutComponent,
        data: { pageLabel: '/influenza/category' },
        canActivate: [CmsPageGuard, WholesalerPharmacyGuard],
      },
      {
        path: 'cart',
        component: PageLayoutComponent,
        data: { pageLabel: '/influenza/cart' },
        canActivate: [CmsPageGuard, WholesalerPharmacyGuard],
      },
      {
        path: 'checkout',
        component: PageLayoutComponent,
        data: { pageLabel: '/influenza/checkout' },
        canActivate: [CmsPageGuard, WholesalerPharmacyGuard],
      },
      {
        path: 'orderConfirmation',
        component: PageLayoutComponent,
        data: { pageLabel: '/influenza/orderConfirmation' },
        canActivate: [CmsPageGuard, WholesalerPharmacyGuard],
      },
      {
        path: 'reservation-overview/:reservationCode',
        component: PageLayoutComponent,
        data: {
          pageLabel: '/influenza/reservation-overview',
        },
        canActivate: [CmsPageGuard, WholesalerPharmacyGuard],
      },
      {
        path: 'order/:orderCode',
        component: PageLayoutComponent,
        data: { pageLabel: '/my-account/order/', isFlu: true },
        canActivate: [CmsPageGuard],
      },
    ],
  },
];
